// src/middleware/useLangNavigate.js
import { useLocation, useNavigate } from "react-router-dom";

export default function useLangNavigate() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = new URLSearchParams(location.search).get("lang") || "en";

  return (path) => {
    const [basePath, query = ""] = path.split("?");
    const searchParams = new URLSearchParams(query);
    searchParams.set("lang", currentLang);
    navigate(`${basePath}?${searchParams.toString()}`);
  };
}
